import React, { ReactNode } from 'react';
import * as BuilderInfoUI from '../BuilderInfoUI';

interface IProps {
  children: ReactNode;
  label?: string;
  hideSeparator?: boolean;
}

export default ({ label, children, hideSeparator }: IProps) => (
  <>
    {!hideSeparator && <BuilderInfoUI.VerticalSeparator />}
    <BuilderInfoUI.PlainInfo>
      {label && <BuilderInfoUI.InfoLabel>{label}</BuilderInfoUI.InfoLabel>}
      <BuilderInfoUI.PlainValue>{children}</BuilderInfoUI.PlainValue>
    </BuilderInfoUI.PlainInfo>
  </>
);
